export enum DiscountApplicationKind {
  ManualExclusion = 'ManualExclusion',
}
